import { getCurrentLangPretty } from '../../helpers/url/urlHelpers';
import {
	IStepOptionalServicesFormInfo,
	StepOptionalServicesSchema,
} from '../registerShipment/registerShipmentForm/stepOptionalServices/stepOptionalServices.schema';
import {
	IStepShipmentFormInfo,
	StepShipmentSchema,
} from '../registerShipment/registerShipmentForm/stepShipment/stepShipment.schema';
import { IStepTypeFormInfo, StepTypeSchema } from '../registerShipment/registerShipmentForm/stepType/stepType.schema';
import { IFormSelectOption } from './../../interfaces/forms/forms';

export interface IRegisterShipmentCalculator
	extends IStepTypeFormInfo,
		IStepShipmentFormInfo,
		IStepOptionalServicesFormInfo {
	country: IFormSelectOption;
	fromPostalCode: IFormSelectOption;
	toPostalCode: IFormSelectOption;
}

export const registerShipmentCalculatorInitialValues: IRegisterShipmentCalculator = {
	country: {
		label: getCurrentLangPretty() === 'en' ? 'Iceland' : 'Ísland',
		value: 'IS',
	},
	dontKnowWeight: false,
	fromPostalCode: null,
	toPostalCode: null,
	service: '',
	parcelCount: 1,
	parcelWeight: 0.5,
	weightCategory: '',
	serviceOption: '',
	serviceName: '',
	serviceOptionPostbox: null,
	serviceOptionParcelpoint: null,
	optionalServices: [],
	optionalServicesNames: [],
	codAmount: '',
	codSsn: '',
	codBank: '',
	codAccountType: '',
	codAccount: '',
	codReference: '',
	insuranceAmount: '',
	insuranceTerms: false,
	parcelHeight: '',
	parcelLength: '',
	parcelWidth: '',
	price: '',
	receiverPhone: '',
	receiverPhoneCountryCode: 'IS',
	senderSsnValid: true,
};

export const RegisterShipmentCalculatorSchema =
	StepTypeSchema.concat(StepShipmentSchema).concat(StepOptionalServicesSchema);
